<template>
  <div class="w-100 p-0 d-flex align-items-center justify-content-around">
    <b-pagination
        class="mb-0"
        v-model="curr"
        :total-rows="this.pageInfo.total"
        :per-page="this.pageInfo.perPage"
        :limit="7"/>
  </div>
</template>

<script>
export default {
  name: "EsgBasePagination",
  props: {
    pageInfo: {
      type: Object,
      required: true,
    },
  },
  created() {
    window.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight') {
        const totalPages = Math.ceil(this.pageInfo.total / this.pageInfo.perPage);
        if (this.curr < totalPages) {
          this.curr += 1;
        }
      } else if (event.key === 'ArrowLeft' && this.curr > 1) {
        this.curr -= 1;
      }
    })
  },
  watch: {
    curr() {
      this.$emit('update:currPage', this.curr)
    }
  },
  data() {
    return {
      curr: 1,
    }
  }
}
</script>

<style scoped>
>>> button {
  height: inherit !important;
}

>>> .page-item .page-link {
  color: #555;
  border-color: #555;
  box-shadow: unset;
}

>>> .page-item.active .page-link {
  font-weight: bolder;
  color: #F9E64D;
  background-color: #000;
  border-color: #555;
  box-shadow: unset;
}

>>> .page-item.disabled .page-link {
  color: #a7a7b0;
  border-color: #a7a7b0;
}

>>> .page-item.disabled.bv-d-xs-down-none .page-link {
  color: #555;
  border-color: #555;
}
</style>